import { HttpSecureClient } from 'path-shared/services/http/httpSecureClient';
import { AuthGuardService } from 'path-shared/services/authentication/auth-guard.service';
import { config } from 'path-shared/configuration/config';
import { api } from 'path-shared/configuration/urls';
import * as i0 from "@angular/core";
import * as i1 from "../../../shared/services/http/httpSecureClient";
import * as i2 from "../../../shared/services/authentication/auth-guard.service";
var AnulacionZonaAzulAutoService = /** @class */ (function () {
    function AnulacionZonaAzulAutoService(http, authGuard) {
        this.http = http;
        this.authGuard = authGuard;
    }
    AnulacionZonaAzulAutoService.prototype.processar = function (anulacionsInfo) {
        if (this.authGuard.canActivate()) {
            return this.http.post(config.urls['apiUrl'] + api.endpoints['urlAnulacionZonaAzulAutoProcessar'], anulacionsInfo);
        }
    };
    AnulacionZonaAzulAutoService.ngInjectableDef = i0.defineInjectable({ factory: function AnulacionZonaAzulAutoService_Factory() { return new AnulacionZonaAzulAutoService(i0.inject(i1.HttpSecureClient), i0.inject(i2.AuthGuardService)); }, token: AnulacionZonaAzulAutoService, providedIn: "root" });
    return AnulacionZonaAzulAutoService;
}());
export { AnulacionZonaAzulAutoService };
